import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react'
import { Card, Nav, Tab } from 'react-bootstrap';
import UserMessagingView from './UserMessagingView';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import UserMessagingShimmer from './UserMessagingShimmer';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import paths from 'routes/paths';

const UserTicketView = () => {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {
        let tokenStr = localStorage.getItem('accessToken');
        try {
            setLoader(true);
            const { data } = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/support/${id}`,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );
            setData(data.data);

        } catch (err) {
            console.log(err);
        } finally {
            setLoader(false);
        }
    }

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'help-center', href: paths.UserHelp, isActive: false },
        { name: 'Individual-ticket', href: paths.UserHelpTickets, isActive: true }
    ];
    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            {loader ? <UserMessagingShimmer /> : <UserMessagingView ticketData={data} loader={loader} />}
        </>
    );
}

export default UserTicketView